import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';
import * as cartService from '/source/js/services/cartService';
import {refreshCart, removeCartLine} from '/source/_patterns/01-components/cart/cart';
import cartPromotionalProductLine from '/source/_patterns/01-components/cart/partials/cartPromotionalProductLine.hbs';

async function addProductPromo() {
    let $isaDeliveryWidget = $('.product-promo');
    let isaDeliveryData = $isaDeliveryWidget.data('isadelivery');
    let array = isaDeliveryData.toString().split('|');
    let isaDeliveryProductId = array[0];
    let priceType = array[1];
    loadSpinner();
    try {
        const result = await cartService.addIsaDeliveryToCart({
            ProductId: `Isagenix_Master|${isaDeliveryProductId}|`,
            Quantity: 1,
            ProductPageRelativeUrl: window.location.pathname,
            PriceType: priceType,
            ContextDatasourceId: $('#hidden-datasource-id').val()
        });
        if(result && result.IsSuccessful) {
            stopSpinner();
            $isaDeliveryWidget.hide();
            result.IsaDeliveryAddedFromWidget = true;
            refreshCart(result);
            addCartLine(result, isaDeliveryProductId);
            $('.remove-cartline').on('click', removeCartLine);
        }
    } catch (e) {
        console.error(e);
    }
}

function addCartLine(result, isaDeliveryProductId) { //eslint-disable-line
    var cartLines = result.CartLineDetails.CartLines;
    var cartListElement = document.getElementsByClassName('cart__productlist');
    var isaDeliveryLine = cartLines.filter(m => m.ProductId === isaDeliveryProductId);
    if(isaDeliveryLine) {
        isaDeliveryLine = isaDeliveryLine[0];
        isaDeliveryLine.DeleteButtonText = result.DeleteButtonText;
        let isaDeliveryLineHtml = cartPromotionalProductLine(isaDeliveryLine);
        cartListElement[0].innerHTML += isaDeliveryLineHtml;
    }
}

function initEventHandlers() {
    $('.product-promo-add').on('click', addProductPromo);
}

$(function() {
    if(!$('.product-promo').length) return;
    initEventHandlers();
});
